export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-8 sm:py-12">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          {/* Company Info and Certification */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-6 sm:mb-8 items-center">
            {/* Company Info */}
            <div className="text-center md:text-left">
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">株式会社インフォレスタ</h3>
              <div className="space-y-2 text-xs sm:text-sm text-gray-300">
                <p>
                  <i className="ri-map-pin-line mr-2 text-teal-400"></i>
                  東京都文京区本郷1-34-1 シャリエ本郷2F
                </p>
                <p>
                  <i className="ri-phone-line mr-2 text-teal-400"></i>
                  TEL：<a href="tel:03-6858-8839" className="hover:text-teal-400 transition-colors cursor-pointer">03-6858-8839</a>
                </p>
                <p>
                  <i className="ri-global-line mr-2 text-teal-400"></i>
                  HP：<a href="http://www.inforesta.com" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors cursor-pointer">www.inforesta.com</a>
                </p>
                <p>
                  営業時間：月～金(土日祝除く) 9:00～17:30
                </p>
              </div>
            </div>

            {/* Certification Image */}
            <div className="flex justify-center md:justify-end">
              <img 
                src="./image/c093b92f28c05c93f0baa61f47560ed9.png" 
                alt="SCC/INT/250210/9854 ISO/IEC 27001:2022 認証" 
                className="h-20 sm:h-24 w-auto object-contain"
              />
            </div>
          </div>

          {/* Links */}
          <div className="border-t border-gray-700 pt-6 sm:pt-8 mb-6 sm:mb-8">
            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 text-xs sm:text-sm">
              <a 
                href="https://www.inforesta.com/top/privacy-landing-page/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer text-center"
              >
                <i className="ri-shield-user-line mr-1"></i>
                プライバシーポリシー
              </a>
              <a 
                href="https://www.inforesta.com/top/description/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer text-center"
              >
                <i className="ri-file-text-line mr-1"></i>
                特定商取引法に基づく表記
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="text-center border-t border-gray-700 pt-6 sm:pt-8">
            <p className="text-gray-400 text-xs sm:text-sm mb-1 sm:mb-2">
              © {new Date().getFullYear()} 株式会社インフォレスタ All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}